// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XF38m9 {
  width: 760px;
  height: auto;
  border-radius: 0;
  padding: var(--spacing-0-5, 4px);
  outline: none;
  user-select: none;
}

.XF38m9 [data-testid\$='-header'] {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  background: transparent;
  padding: var(--spacing-3, 24px);
  min-height: auto;
  width: auto;
}

.XF38m9 [data-testid\$='-close-button'] {
  background: rgba(255, 255, 255, 0.9);
  color: var(--text-neutral-dark);
  width: 40px;
  height: 40px;
  box-shadow: var(--shadow-sm, 0 2px 8px rgba(0, 0, 0, 0.15));
  margin-left: 0;
  transition: var(--transition-all, all 0.2s ease);
}

.XF38m9 [data-testid\$='-close-button']:hover {
  background: var(--surface-neutral-white, rgba(255, 255, 255, 1));
  transform: scale(1.05);
}

.XF38m9 [data-testid\$='-body'] {
  padding: 0;
}

@media (max-width: 768px) {
  .XF38m9 {
    width: 95vw;
    height: 90vh;
    max-width: 400px;
  }

  .UrH2FY {
    height: 50%;
  }

  .XynTcv {
    padding: var(--spacing-3, 24px);
    gap: var(--spacing-3, 24px);
  }

  .PZzT8Q {
    font-size: var(--font-size-xl, 20px);
  }

  .Pj9qoz {
    font-size: var(--font-size-sm, 14px);
  }

  .vaEKmf {
    max-width: 100%;
  }

  .kLGg0I {
    max-width: 100%;
  }
}

.UrH2FY {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: 100%;
  gap: var(--spacing-4, 32px);
  padding: 0;
  background: linear-gradient(135deg, var(--surface-tertiary-strong) 0%, var(--surface-tertiary-medium) 100%);
  position: relative;
}

.UrH2FY img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  display: block;
}

.XynTcv {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  gap: var(--spacing-4, 12px);
  padding: var(--spacing-4, 24px) var(--spacing-4, 32px) var(--spacing-4, 32px);
  position: relative;
  text-align: center;
}

.kLGg0I {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  gap: var(--spacing-3, 16px);
  padding: var(--spacing-4, 32px) var(--spacing-4, 32px) var(--spacing-4, 32px);
}

.vaEKmf {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2, 16px);
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  align-items: center;
}

.PZzT8Q {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-2xl, 24px);
  line-height: var(--line-height-160, 1.25);
  color: var(--text-neutral-dark, #333333);
  margin: 0;
  text-align: center;
  max-width: 680px;
}

.Pj9qoz {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--type-paragraph-md-font-size, 16px);
  line-height: var(--line-height-160, 1.6);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  text-align: center;
  max-width: 570px;
}

.eIUpjt {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-semibold, 800);
  font-size: var(--type-paragraph-md-font-size, 16px);
  line-height: var(--line-height-160, 1.6);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  text-align: center;
  max-width: 570px;
}

._SUJwG {
  display: flex;
  align-items: center;
  width: 200px;
  justify-content: start;
}

._SUJwG button {
  background: none;
  border: 0;
  padding: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.tukNGE {
  transform: scaleX(-1);
}

.dInUYA {
  display: flex;
  align-items: center;
  width: 200px;
  justify-content: end;
}

.dInUYA button {
  background: none;
  border: 0;
  padding: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.rEwWOF {
  height: 100%;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gfpERi {
  display: flex;
  width: 200px;
  justify-content: end;
  align-items: center;
}

.W_clRx {
  width: 140px !important;
  background-color: var(--surface-primary-medium);
  border-color: var(--surface-primary-medium);
}

.W_clRx:hover {
  background-color: var(--surface-primary-strong);
  border-color: var(--surface-primary-strong);
}

.W_clRx:active {
  background-color: var(--surface-primary-strong);
  border-color: var(--surface-primary-strong);
}

.KluFYH {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--type-paragraph-md-font-size, 16px);
  line-height: var(--line-height-160, 1.6);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  text-align: center;
  max-width: 570px;
}

.mfgVY0 {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--type-paragraph-md-font-size, 16px);
  line-height: var(--line-height-160, 1.6);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  align-self: flex-start;
  text-align: left;
}

.oCraUQ {
  width: 100%;
  margin: 0;
  padding-left: var(--spacing-3, 20px);
  list-style: disc;
  text-align: left;
  align-self: center;
}

.xO6kqX {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--type-paragraph-md-font-size, 16px);
  line-height: var(--line-height-160, 1.6);
  color: var(--text-neutral-dark, #1f1f1f);
  margin: var(--spacing-0-5, 4px) 0;
}

.aI22VB {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-sm, 14px);
  line-height: var(--line-height-160, 1.6);
  color: var(--text-neutral-dark, #666666);
  text-align: center;
  margin: 0;
  padding-bottom: var(--spacing-0-5, 4px);
}

.CvWbAr {
  font-weight: 600;
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: var(--text-primary-medium, var(--surface-primary-medium));
  text-decoration: underline;
  cursor: pointer;
}

.MGW0Rs > span {
  font-weight: 600;
}

.A86oLV {
  min-width: 280px;
  width: 640px;
  font-weight: 400;
  text-align: start;
}

.u7aV9D {
  max-height: 60vh;
  overflow-y: auto;
  text-align: left;
  white-space: pre-line;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-sm, 14px);
  line-height: var(--line-height-160, 1.6);
  color: var(--text-neutral-dark, #1f1f1f);
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/BillingWelcomeWizard/BillingWelcomeWizard.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,2DAA2D;EAC3D,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;IAC/B,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,UAAU;EACV,2GAA2G;EAC3G,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;EAC3B,6EAA6E;EAC7E,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,6EAA6E;AAC/E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iEAAiE;EACjE,6CAA6C;EAC7C,qCAAqC;EACrC,yCAAyC;EACzC,wCAAwC;EACxC,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,mDAAmD;EACnD,wCAAwC;EACxC,wCAAwC;EACxC,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iEAAiE;EACjE,6CAA6C;EAC7C,mDAAmD;EACnD,wCAAwC;EACxC,wCAAwC;EACxC,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,mDAAmD;EACnD,wCAAwC;EACxC,wCAAwC;EACxC,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,mDAAmD;EACnD,wCAAwC;EACxC,wCAAwC;EACxC,SAAS;EACT,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,mDAAmD;EACnD,wCAAwC;EACxC,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,wCAAwC;EACxC,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;EACT,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,gEAAgE;EAChE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,iEAAiE;EACjE,oCAAoC;EACpC,wCAAwC;EACxC,wCAAwC;AAC1C","sourcesContent":[".billingWelcome {\n  width: 760px;\n  height: auto;\n  border-radius: 0;\n  padding: var(--spacing-0-5, 4px);\n  outline: none;\n  user-select: none;\n}\n\n.billingWelcome :global([data-testid$='-header']) {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 10;\n  background: transparent;\n  padding: var(--spacing-3, 24px);\n  min-height: auto;\n  width: auto;\n}\n\n.billingWelcome :global([data-testid$='-close-button']) {\n  background: rgba(255, 255, 255, 0.9);\n  color: var(--text-neutral-dark);\n  width: 40px;\n  height: 40px;\n  box-shadow: var(--shadow-sm, 0 2px 8px rgba(0, 0, 0, 0.15));\n  margin-left: 0;\n  transition: var(--transition-all, all 0.2s ease);\n}\n\n.billingWelcome :global([data-testid$='-close-button']:hover) {\n  background: var(--surface-neutral-white, rgba(255, 255, 255, 1));\n  transform: scale(1.05);\n}\n\n.billingWelcome :global([data-testid$='-body']) {\n  padding: 0;\n}\n\n@media (max-width: 768px) {\n  .billingWelcome {\n    width: 95vw;\n    height: 90vh;\n    max-width: 400px;\n  }\n\n  .header {\n    height: 50%;\n  }\n\n  .content {\n    padding: var(--spacing-3, 24px);\n    gap: var(--spacing-3, 24px);\n  }\n\n  .title {\n    font-size: var(--font-size-xl, 20px);\n  }\n\n  .description {\n    font-size: var(--font-size-sm, 14px);\n  }\n\n  .textContent {\n    max-width: 100%;\n  }\n\n  .actions {\n    max-width: 100%;\n  }\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  height: 100%;\n  gap: var(--spacing-4, 32px);\n  padding: 0;\n  background: linear-gradient(135deg, var(--surface-tertiary-strong) 0%, var(--surface-tertiary-medium) 100%);\n  position: relative;\n}\n\n.header img {\n  width: 100%;\n  height: 220px;\n  object-fit: cover;\n  display: block;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 240px;\n  gap: var(--spacing-4, 12px);\n  padding: var(--spacing-4, 24px) var(--spacing-4, 32px) var(--spacing-4, 32px);\n  position: relative;\n  text-align: center;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 60px;\n  gap: var(--spacing-3, 16px);\n  padding: var(--spacing-4, 32px) var(--spacing-4, 32px) var(--spacing-4, 32px);\n}\n\n.textContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2, 16px);\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto;\n  align-items: center;\n}\n\n.title {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-2xl, 24px);\n  line-height: var(--line-height-160, 1.25);\n  color: var(--text-neutral-dark, #333333);\n  margin: 0;\n  text-align: center;\n  max-width: 680px;\n}\n\n.description {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--type-paragraph-md-font-size, 16px);\n  line-height: var(--line-height-160, 1.6);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  text-align: center;\n  max-width: 570px;\n}\n\n.subscription {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-semibold, 800);\n  font-size: var(--type-paragraph-md-font-size, 16px);\n  line-height: var(--line-height-160, 1.6);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  text-align: center;\n  max-width: 570px;\n}\n\n.actionBack {\n  display: flex;\n  align-items: center;\n  width: 200px;\n  justify-content: start;\n}\n\n.actionBack button {\n  background: none;\n  border: 0;\n  padding: 8px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n}\n\n.buttonBackIcon {\n  transform: scaleX(-1);\n}\n\n.actionNext {\n  display: flex;\n  align-items: center;\n  width: 200px;\n  justify-content: end;\n}\n\n.actionNext button {\n  background: none;\n  border: 0;\n  padding: 8px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n}\n\n.actionCenter {\n  height: 100%;\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.actionsContentButton {\n  display: flex;\n  width: 200px;\n  justify-content: end;\n  align-items: center;\n}\n\n.actionsButton {\n  width: 140px !important;\n  background-color: var(--surface-primary-medium);\n  border-color: var(--surface-primary-medium);\n}\n\n.actionsButton:hover {\n  background-color: var(--surface-primary-strong);\n  border-color: var(--surface-primary-strong);\n}\n\n.actionsButton:active {\n  background-color: var(--surface-primary-strong);\n  border-color: var(--surface-primary-strong);\n}\n\n.subtitle {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--type-paragraph-md-font-size, 16px);\n  line-height: var(--line-height-160, 1.6);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  text-align: center;\n  max-width: 570px;\n}\n\n.afterPeriod {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--type-paragraph-md-font-size, 16px);\n  line-height: var(--line-height-160, 1.6);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  align-self: flex-start;\n  text-align: left;\n}\n\n.bulletList {\n  width: 100%;\n  margin: 0;\n  padding-left: var(--spacing-3, 20px);\n  list-style: disc;\n  text-align: left;\n  align-self: center;\n}\n\n.bulletItem {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--type-paragraph-md-font-size, 16px);\n  line-height: var(--line-height-160, 1.6);\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: var(--spacing-0-5, 4px) 0;\n}\n\n.consent {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-sm, 14px);\n  line-height: var(--line-height-160, 1.6);\n  color: var(--text-neutral-dark, #666666);\n  text-align: center;\n  margin: 0;\n  padding-bottom: var(--spacing-0-5, 4px);\n}\n\n.consentLink {\n  font-weight: 600;\n  background: none;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  color: var(--text-primary-medium, var(--surface-primary-medium));\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.alertContent > span {\n  font-weight: 600;\n}\n\n.alert {\n  min-width: 280px;\n  width: 640px;\n  font-weight: 400;\n  text-align: start;\n}\n\n.termsModalText {\n  max-height: 60vh;\n  overflow-y: auto;\n  text-align: left;\n  white-space: pre-line;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-sm, 14px);\n  line-height: var(--line-height-160, 1.6);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"billingWelcome": `XF38m9`,
	"header": `UrH2FY`,
	"content": `XynTcv`,
	"title": `PZzT8Q`,
	"description": `Pj9qoz`,
	"textContent": `vaEKmf`,
	"actions": `kLGg0I`,
	"subscription": `eIUpjt`,
	"actionBack": `_SUJwG`,
	"buttonBackIcon": `tukNGE`,
	"actionNext": `dInUYA`,
	"actionCenter": `rEwWOF`,
	"actionsContentButton": `gfpERi`,
	"actionsButton": `W_clRx`,
	"subtitle": `KluFYH`,
	"afterPeriod": `mfgVY0`,
	"bulletList": `oCraUQ`,
	"bulletItem": `xO6kqX`,
	"consent": `aI22VB`,
	"consentLink": `CvWbAr`,
	"alertContent": `MGW0Rs`,
	"alert": `A86oLV`,
	"termsModalText": `u7aV9D`
};
module.exports = ___CSS_LOADER_EXPORT___;
